const helpers = module.exports = {}
const config = require('../../../../../config/generatedConfig')

helpers.toPrice = (str) => {
  let price = str
  while (price.length < 3) {
    price = '0' + price
  }

  const [pounds, pence] = [price.slice(0, -2), price.slice(-2)]
  return `${config.settings.priceFormat}${pounds}${config.settings.decimalNotation}${pence}`
}


// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/vouchers/helpers.js